/**
 * AVS-4517: the session this tab ended while the server has not yet confirmed the end. Remote
 * records for it are dropped meanwhile, so another tab's late write cannot revive it locally.
 * One end at a time: a newer mark replaces the older one, and a clear only removes its own mark.
 */
let pending: { id: string; token: symbol } | undefined;

export function markEndPending(id: string): symbol {
  const token = Symbol('end-pending');
  pending = { id, token };
  return token;
}

export function clearEndPending(token: symbol | undefined): void {
  if (token === undefined || pending?.token === token) {
    pending = undefined;
  }
}

export function isEndPending(id: string | undefined): boolean {
  return !!id && pending?.id === id;
}
